import React, { useEffect } from "react";
import { Link } from "react-router-dom";
// import Header from "../components/Frontend/Header";
// import Footer from "../components/Frontend/Footer";
// import FrequentlyAskedQuestion from "../components/PublicPagesReusable/FrequentlyAskedQuestion";
// import SkillAssment from "../components/PublicPagesReusable/SkillAssment";
// import WhyChoose from "../components/PublicPagesReusable/WhyChoose";
import { Helmet } from "react-helmet";
import ReactGA from "react-ga";
import Profile from "../../../assets/images/public-pages/grey-profile.svg";
import Frame1 from "../../../assets/images/public-pages/Frame1.svg"
import Frame2 from "../../../assets/images/public-pages/Frame2.svg"
import Frame3 from "../../../assets/images/public-pages/Frame3.svg"
import Frame4 from "../../../assets/images/public-pages/Frame4.svg"
import Frame5 from "../../../assets/images/public-pages/Frame5.svg";
import Frame6 from "../../../assets/images/public-pages/Frame6.svg";
import Frame7 from "../../../assets/images/public-pages/Frame7.svg";
import Frame8 from "../../../assets/images/public-pages/Frame8.svg";
import Frame9 from "../../../assets/images/public-pages/Frame9.svg";
import Frame10 from "../../../assets/images/public-pages/Frame10.svg";
import Frame11 from "../../../assets/images/public-pages/Frame11.svg";
import Frame12 from "../../../assets/images/public-pages/Frame12.svg";
import Frame13 from "../../../assets/images/public-pages/Frame13.svg";
import Frame14 from "../../../assets/images/public-pages/Frame14.svg";
import Frame15 from "../../../assets/images/public-pages/Frame15.svg";
import Frame16 from "../../../assets/images/public-pages/Frame16.svg";
import Frame17 from "../../../assets/images/public-pages/Frame17.svg";
import Frame18 from "../../../assets/images/public-pages/Frame18.svg";
import Frame19 from "../../../assets/images/public-pages/Frame19.svg";
import Speaking from "../../../assets/images/public-pages/speaking-mastery.png";
import Writing from "../../../assets/images/public-pages/90-listening.png";
import Reading from "../../../assets/images/public-pages/reading-techniques.png"
import Listening from "../../../assets/images/public-pages/accuracy-drills.png"
import Globe from "../../../assets/images/public-pages/globe.svg"
import Report from "../../../assets/images/public-pages/report.svg";
import CheckList from "../../../assets/images/public-pages/check-list.svg";
import Filter from "../../../assets/images/public-pages/filter.svg"
import Reward from "../../../assets/images/public-pages/flexible-icon.svg"
import Global from "../../../assets/images/public-pages/reward.svg"

// import bannerImage from "../assets/images/public-pages/pte-parramatta.png"
import bannerImage from "../../../assets/images/public-pages/New-Public-banner.webp"
// import ReactPixel from "react-facebook-pixel";
// import CrackedCodeSlider from "../components/Frontend/Sliders/CrackedCodeSlider";
// import LetsCoaching from "components/PublicPagesReusable/LetsCoaching";
// import BannerSection from "components/PublicPagesReusable/BannerSection";
import "../../../assets/css/pte-responsive.css";
import Immigration from "../../../assets/images/public-pages/victoria-take-test.png";
import ImmigrationSecond from "../../../assets/images/public-pages/Immigration-second.png";
import PteDashboardImage from "../../../assets/images/public-pages/Newdashboard.png"
import BannerHeader from "components/PublicPagesReusable/BannerHeader";
// import ReusableHomePageSlider from "./ReusableHomePageSlider";
import ButtonComp from "components/PublicPagesReusable/ButtonComp";
import ContentImageSection from "components/PublicPagesReusable/ContentImageSection";
import SkillAreas from "components/PublicPagesReusable/SkillAreas";
import ComparisonSection from "components/PublicPagesReusable/ComparisionSection";
import SplitSection from "components/PublicPagesReusable/SplitSection";
import TestSection from "components/PublicPagesReusable/TestSection";
import PromiseSection from "components/PublicPagesReusable/PromiseSection";
import TestimonialSection from "components/PublicPagesReusable/TestimonialSection";
import AiPower from "components/PublicPagesReusable/AiPowerSection";
import PteAppBanner from "components/PublicPagesReusable/PteAppBanner";
import FaqSection from "components/PublicPagesReusable/FaqSection";
import ContentPriceSection from "components/PublicPagesReusable/ContentPriceSection";
import Footer from "../Footer";
import Header from "../Header";
import ReusableHomePageSlider from "page/ReusableHomePageSlider";
import CtaBanner from "components/PublicPagesReusable/CtaBanner";
import HeroSectionUpdated from "components/PublicPagesReusable/HeroSectionUpdated";
import PteConsultation from "components/PublicPagesReusable/PteConsultation";
import CTAContactSection from "components/PublicPagesReusable/CTAContactSection";
import IconCall from "../../../assets/images/public-pages/blue-call.svg";
import IconEmail from "../../../assets/images/public-pages/blue-email.svg";
import IconChats from "../../../assets/images/public-pages/blue-chats.svg";
import IconLocation from "../../../assets/images/public-pages/blue-location.svg";
import IconClock from "../../../assets/images/public-pages/blue-clock.svg";
import IconInfo from "../../../assets/images/public-pages/blue-info.svg";
import ProvenResult from "../../../assets/images/public-pages/proven-result.svg";
import ExpertFaculty from "../../../assets/images/public-pages/expert-faculty.svg";
import Learning from "../../../assets/images/public-pages/learning.svg";
import Screening from "../../../assets/images/public-pages/Screening.svg";
import CourseCard from "components/PublicPagesReusable/CourseCard";
import Document from "../../../assets/images/public-pages/grey-doc.svg";
import GreenDocument from "../../../assets/images/public-pages/green-doc.svg";
import TickCircle from "../../../assets/images/public-pages/green-tick-circle.png"

const questions = [
  {
    question: "How long does PTE preparation take with your PTE on campus Classes?",
    answer:
      "Most students require 4-6 weeks of consistent preparation to achieve their target scores, though this depends on your current proficiency.",
  },
  {
    question: "Do I get a money-back guarantee?",
    answer:
      "We don't offer money-back guarantees because we focus on delivering results, not refunds. Our proven methods and expert guidance ensure you succeed from the start - that's why thousands of students have achieved their target PTE scores with us.",
  },
  {
    question: "Do you offer both online and in-person PTE on campus Classes?",
    answer:
      "Yes! We provide both online coaching and PTE on campus Classes to accommodate different learning preferences and schedules.",
  },
  {
    question: "How can I book a free demo class for PTE on campus Classes?",
    answer: `You can book your free demo PTE on campus Classes by calling us on <a href="tel:+61426230061">+61 426230061</a> or emailing us at <a href="mailto:info@languageacademy.com.au">info@languageacademy.com.au</a>`,
  },
  {
    question:
      "What makes Language Academy the top PTE Institute offering PTE on campus Classes?",
    answer:
      "Our combination of expert tutors, proven methodologies, AI-powered practice tools, and personalized PTE on campus Classes approach has helped thousands of students achieve their target PTE scores.",
  },
  {
    question:
      "Are there any prerequisites for joining the PTE on campus Classes?",
    answer:
      "No specific prerequisites are required. Our PTE on campus Classes program is designed to help students of all English proficiency levels improve their scores and achieve their goals.",
  },
];

const images = [{
  src: Frame1,
  alt: "score-1",
},
{
  src: Frame2,
  alt: "score-2",
},
{
  src: Frame3,
  alt: "score-3",
},
{
  src: Frame4,
  alt: "score-4",
},
{
  src: Frame5,
  alt: "score-5",
},
{
  src: Frame6,
  alt: "score-6",
}, {
  src: Frame7,
  alt: "score-7",
},
{
  src: Frame8,
  alt: "score-8",
},
{
  src: Frame9,
  alt: "score-9",
},
{
  src: Frame10,
  alt: "score-10",
},
{
  src: Frame11,
  alt: "score-11",
},
{
  src: Frame12,
  alt: "score-12",
},
{
  src: Frame13,
  alt: "score-13",
},
{
  src: Frame14,
  alt: "score-14",
}, {
  src: Frame15,
  alt: "score-15",
},
{
  src: Frame16,
  alt: "score-16",
},
{
  src: Frame17,
  alt: "score-17",
},
{
  src: Frame18,
  alt: "score-18",
},
{
  src: Frame19,
  alt: "score-19",
}
];


const heroDescriptionSection = () => {
  return (
    <>
      <p className="sub-title text-center FS16FW500">
        Ready to secure your desired PTE score? Our specialized PTE Online Coaching VIC programs deliver proven results for students across Melbourne
        <br /> & Geelong, Ballarat, Bendigo, Shepparton & regional Victoria. </p>
    </>)
}

const contentSection = () => {
  return (
    <h3 className="top-section-text FS40FW600">
      Transform Your Future with<br />
      <span className="text-success FS40FW600">PTE Online Coaching in Victoria</span>
    </h3>
  )
}

const skillAreaTitle = () => {
  return (
    <h3 className="top-section-text mb-4 white FS40FW600">
      Learn With <span className="text-success FS40FW600">Language Academy <br /></span> -
      Watch Our Tutorials </h3>
  )
}

const lifestyleCards = [
  {
    title: "Speaking Mastery ",
    color: "transparent",
    img: Speaking,
    width: "100%",
    height: "100%",
    transform: " rotate(-5deg)",
    // minHeight:"317px",
    videoUrl: "3rRY96mbizY"
  },
  {
    title: "PTE 90/90 Method",
    color: "transparent",
    img: Writing,
    width: "100%",
    height: "100%",
    transform: " rotate(-5deg)",
    // minHeight:"317px",
    videoUrl: "t4oyY3EPYGQ"
  },
  {
    title: "Secret Scoring Guide",
    color: "transparent",
    img: Reading,
    width: "100%",
    height: "100%",
    transform: " rotate(-5deg)",
    // minHeight:"317px",
    videoUrl: "IPy4d8zzV2U"
  },
  {
    title: "Writing Mistakes and their Fix",
    color: "transparent",
    img: Listening,
    width: "100%",
    height: "100%",
    transform: " rotate(-5deg)",
    // minHeight:"317px",
    videoUrl: "U8yBis5fGn0"
  },
];

const skillAreaTitle2 = () => {
  return (
    <h3 className="top-section-text FS40FW600">
      Why Thousands Choose Our <br />
      <span className="text-success FS40FW600">PTE Online Course in VIC</span><br />
    </h3>
  )
}

const skillAreaTitle3 = () => {
  return (
    <h3 className="top-section-text FS40FW600">
      PTE Online Course Structure <br />
      <span className="text-success FS40FW600">For Victoria Students</span><br />
    </h3>
  )
}

const skillAreaTitle4 = () => (
  <h3 className="top-section-text FS40FW600">
    Strategic Score Targets:<br />
    <span className="text-success FS40FW600">Tailored Pathways for Victoria Students</span>
  </h3>
);

const styleCards = [
  {
    title: "Proven Results Across Victoria ",
    text: (
      <ul className="feature-list plus-sans FS16FW500 fw-400">
        <li><span className="fw-800">50,000+</span> successful students</li>
        <li>Average score improvement of <span className="fw-800">20+ points</span></li>
        <li>Specialized coaching for <span className="fw-800">50+, 65+, 79+</span> score targets</li>
      </ul>
    ),
    color: "#141414",
   img: ProvenResult,
   boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
  borderColor:'rgba(0, 0, 0, 0.05)'
  },
  {
    title: "Expert Faculty Team",
    text: (
      <ul className="feature-list plus-sans FS16FW500 fw-400">
        <li>Certified<span className="fw-800"> PTE trainers</span></li>
        <li>Updated training based on the <span className="fw-800">latest PTE patterns</span></li>
        <li><span className="fw-800">Personalised feedback </span>for every student</li>
      </ul>
    ),
    color: "#141414",
  img: ExpertFaculty,
  boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
  borderColor:'rgba(0, 0, 0, 0.05)'
  },
  {
    title: "Flexible Online Learning ",
    text: (
      <ul className="feature-list plus-sans FS16FW500 fw-400">
        <li><span className="fw-800">Live </span>interactive classes</li>
        <li><span className="fw-800">Recorded sessions </span>for version</li>
        <li><span className="fw-800">Weekend and evening </span>batches available </li>
      </ul>
    ),
    color: "#141414",
     img: Learning,
     boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
    borderColor:'rgba(0, 0, 0, 0.05)'
  },
  {
    title: "Advanced Practice Platform",
    text: (
      <ul className="feature-list plus-sans FS16FW500 fw-400">
        <li><span className="fw-800">AI-powered </span>mock tests</li>
        <li><span className="fw-800">Section-wise </span>score analysis</li>
        <li><span className="fw-800">Updated question bank </span>aligned with the current format</li>
      </ul>
    ),
    color: "#141414",
   img: Screening,
   boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
    borderColor:'rgba(0, 0, 0, 0.05)'
  }
];
const styleCards2 = [
  {
    title: "Foundation Module ",
    greenTitle: "FUNDAMENTALS",
    text: (
      <ul className="plus-sans FS16FW500 fw-400 px-0">
        <li className="d-flex align-items-start gap-2 mb-3"><img src={TickCircle} alt="Check" className="list-data" /> Basic concept clarity</li>
        <li className="d-flex align-items-start gap-2 mb-3"><img src={TickCircle} alt="Check" className="list-data" /> Introduction to scoring logic</li>
        <li className="d-flex align-items-start gap-2"><img src={TickCircle} alt="Check" className="list-data" /> Enabling skill improvement </li>
      </ul>
    ),
    color: "#141414",
    boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
    borderColor:'rgba(0, 0, 0, 0.05)'
  },
  {
    title: "Skill Enhancement Module ",
    greenTitle: "DEVELOPMENT",
    text: (
      <ul className="plus-sans FS16FW500 fw-400 px-0">
        <li className="d-flex align-items-start gap-2 mb-3"><img src={TickCircle} alt="Check" className="list-data" /> Speaking fluency drills</li>
        <li className="d-flex align-items-start gap-2 mb-3"><img src={TickCircle} alt="Check" className="list-data" /> Reading speed development </li>
        <li className="d-flex align-items-start gap-2 mb-3"><img src={TickCircle} alt="Check" className="list-data" /> Writing structure mastery</li>
        <li className="d-flex align-items-start gap-2"><img src={TickCircle} alt="Check" className="list-data" /> Listening accuracy practice</li>
      </ul>
    ),
    color: "#141414",
    boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
    borderColor:'rgba(0, 0, 0, 0.05)'
  },
  {
    title: "Mock Test & Feedback Phase ",
    greenTitle: "ASSESSMENT",
    text: (
      <ul className="plus-sans FS16FW500 fw-400 px-0">
        <li className="d-flex align-items-start gap-2 mb-3"><img src={TickCircle} alt="Check" className="list-data" /> Full-length computer-based mock tests</li>
        <li className="d-flex align-items-start gap-2 mb-3"><img src={TickCircle} alt="Check" className="list-data" /> Detailed performance reports </li>
        <li className="d-flex align-items-start gap-2"><img src={TickCircle} alt="Check" className="list-data" /> One-on-one improvement sessions</li>
      </ul>
    ),
    color: "#141414",
    boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
    borderColor:'rgba(0, 0, 0, 0.05)'
  }
];

const blockInfo = () =>
(
  <p className="desc block-info">Ready to start your journey to success? Call us at ,<span className="white fw-bold"> +61 426230061</span> or email us at <br /> <span className="white fw-bold">  info@languageacademy.com.au</span> for any queries and doubts you may have.</p>)

const extratitle = () => (
  <h2 className="hero-title FS40FW600 mb-3">
    What makes
    <span className="text-success FS40FW600"> Us Different</span>
  </h2>
)

const testData = {
  title: 'Why Choose Us for <br/>',
  highlight: "PTE Online Coaching VIC?",
  bottomDescription: 'We are committed to helping students across Victoria achieve their target scores <br/>with structured preparation and expert guidance. ',
  cta: "Start Your PTE Preparation Today",
  list: [
    "Comprehensive PTE Online Classes in VIC",
    "AI-based real exam simulation",
    "Flexible schedules for working professionals",
    "Updated question bank",
    "Personalised mentoring",
    "High success rate across Victoria"
  ]
};

const sliderList = {
  title: "Success Stories from <span>Victoria Students</span>",
  subtitle: "Real success stories from our learners",

  settings: {
    slidesPerView: 3,
    spaceBetween: 20,
    breakpoints: {
      0: { slidesPerView: 1 },
      768: { slidesPerView: 2 },
      1024: { slidesPerView: 3 },
    },
  },

  items: [
    {
      id: 1,
      name: "Emily R.",
      location: "Melbourne",
      description:
        "Improved from 56 to 79 in just 8 weeks. The online mock tests made the difference.",
      image: Profile,
    },
    {
      id: 2,
      name: "Arjun S.",
      location: "Geelong",
      description:
        "Achieved 65+ in first attempt. Flexible online classes helped me manage work and preparation",
      image: Profile,
    },
    {
      id: 3,
      name: "Parneet Khairi",
      location: "Ballarat",
      description:
        "Finally cleared my migration requirement after two previous attempts elsewhere.",
      image: Profile,
    }
  ],
};


const faqQuestions = [
  {
    question: "How long does PTE preparation take in VIC? ",
    answer: "Preparation time relies on your current English level and target score. Most students in Victoria achieve their goals within 4 to 10 weeks with consistent online coaching and guided practice. "
  },
  {
    question: "Are online PTE classes as effective as classroom training? ",
    answer: "Yes. Our PTE Online Course in VIC delivers the same curriculum, live interaction, and feedback system as physical classes, with added flexibility for working professionals. "
  },
  {
    question: "What is included in your PTE Online Coaching in Victoria program? ",
    answer: "Live classes, recorded sessions, AI mock tests, personalised feedback, updated study materials, and structured performance tracking. "
  },
  {
    question: "Do you provide flexible batch timings for Victoria students? ",
    answer: "Yes. We offer weekday, weekend, and evening batches to accommodate different schedules across Victoria"
  }
];

const Victoria = () => {
  useEffect(() => {
    ReactGA.initialize("UA-157984080-1");
    ReactGA.pageview(window.location.pathname + window.location.search);

    // ReactPixel.init("197333187452630");
    // ReactPixel.pageView();
  }, []);

  const heroWorkTitle = () => {
    return (
      <h1 className="FS48 fw-500 top-section-text">
        <span className="text-success fw-600">PTE Online Coaching in Victoria - <br/></span>
        {/* <br /> */}
        Master English Proficiency with <br/>Expert-Led Virtual Training
      </h1>
    );
  };

  const heroData = {
    badge: "50,000+ Students' Success Stories",
    title: heroWorkTitle,
    subtitle: "Flexible online classes. Expert trainers. AI-powered mock tests. Real score improvement. ",
    btn_prepration: { text: "Book Your Free PTE Assessment", onClick: () => openPopup() },
    btn_outline: { text: "Demo Class", variant: "outline", onClick: () => openPopup() },
    users: [
      "/images/web-new-images/new-content-slider/User-01.svg",
      "/images/web-new-images/new-content-slider/User-02.svg",
      "/images/web-new-images/new-content-slider/User-03.svg",
      "/images/web-new-images/new-content-slider/RamimRahman-demo.svg",
      "/images/web-new-images/new-content-slider/SapnaPandey-demo.svg",
    ],
    trustText: "Trusted by 50,000+ students",
    profile: {
      image: "/images/web-new-images/new-content-slider/Varun-sir-hero.webp",
      stats: [
        { value: "50K+", label: "STUDENTS" },
        { value: "95%", label: "SUCCESS RATE" },
        { value: "10+", label: "LOCATIONS" }
      ]
    },
    bottomStats: [
      { value: "8", highlight: '+', label: "Years of PTE Expertise" },
      { value: "30", highlight: '+', label: "Countries Served" },
      { value: "/5", highlight: '4.8', label: "Rated PTE Practice App" },
      { value: "-Powered", highlight: 'AI', label: "Scoring Engine" }
    ]
  };

const openPopup = () => {
  const modal = new window.bootstrap.Modal(
    document.getElementById("staticBackdrop")
  );
  modal.show();
};

const tableData = [
  {
    id: 1,
    img: Document, // replace with your icon
    hoverImg: GreenDocument,
    badge: "Beginners",
    title: "Online Foundation",
    text: "Core modules + practice",
    btnText: "Enroll Now",
    width:"28px",
    height:"28px",
    link: "/auth/register",
  },
  {
    id: 2,
    img: Document,
    hoverImg: GreenDocument,
    badge: "65+ & 79+ targets",
    title: "Advanced Target Batch",
    text: "Intensive coaching + mocks",
    btnText: "Join Today",
    width:"28px",
    height:"28px",
    link: "/auth/register",
  },
  {
    id: 3,
    img: Document,
    hoverImg: GreenDocument,
    badge: "Fast-track students",
    title: "One-On-One Mentoring",
    text: "Personal strategy + direct feedback",
    btnText: "Book Consultation",
    width:"28px",
    height:"28px",
    link: openPopup,
  },
];

  return (
    <React.Fragment>
      <Helmet>
        <title>Top PTE, NAATI & IELTS Coaching Victoria | LA Language Academy</title>
        <meta
          name="description"
          content="Prepare for PTE, NAATI and IELTS in Victoria with our expert trainers, real exam mock tests, and personalized coaching for higher PTE scores. Join now!"
        />
        <meta name="robots" content="index, follow" />
        <link
          rel="canonical"
          href="https://www.languageacademy.com.au/city/victoria"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@languageacademy" />
        <meta
          name="twitter:title"
          content="Top PTE, NAATI & IELTS Coaching Victoria | LA Language Academy"
        />
        <meta
          name="twitter:description"
          content="Prepare for PTE, NAATI and IELTS in Victoria with our expert trainers, real exam mock tests, and personalized coaching for higher PTE scores. Join now!"
        />
        <meta
          name="twitter:image"
          content="https://www.languageacademy.com.au/images/logol.png"
        />
        <meta name="twitter:image:alt" content="LA Language Academy Logo" />
        <meta
          property="og:url"
          content="https://www.languageacademy.com.au/city/victoria"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Top PTE, NAATI & IELTS Coaching Victoria | LA Language Academy"
        />
        <meta
          property="og:description"
          content="Prepare for PTE, NAATI and IELTS in Victoria with our expert trainers, real exam mock tests, and personalized coaching for higher PTE scores. Join now!"
        />
        <meta
          property="og:image"
          content="https://www.languageacademy.com.au/images/logol.png"
        />
        <meta property="og:image:alt" content="LA Language Academy Logo" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
      </Helmet>
      <div className="new-design">
        <Header />
        <HeroSectionUpdated data={heroData} />

        <div className="fame-wall off-white">
          <ReusableHomePageSlider images={images} />
        </div>

        <div className="d-flex align-items-center gap-4 flex-column pb-4 off-white">
          {heroDescriptionSection()}
          <ButtonComp link={openPopup} btnText={"Book Your Free PTE Assessment"} img={"/images/web-new-images/new-dark-arrow.svg"} />
        </div>

        <PteConsultation />

        <div className="custom-container py-5">
          <ContentImageSection
            contentSection={contentSection}
            quoteText={"Our <span class='plus-sans fw-700 FS18FW400'>PTE Online Coaching in Victoria</span> programs are designed for ambitious students who need structured preparation, flexible learning, and measurable results."}
            btnLink="/contact"
            btnText="Contact Us to Start Your Preparation"
            btnClassName="mt-4"
            image={Immigration}
            imageClassName="immigration-test-img"
            reverse={true}
            paragraphs={[
              "Whether you are applying for skilled migration, university admission, or professional registration, our PTE Online Classes in VIC provide the tools and guidance needed to succeed.",
              "We combine live interactive sessions with AI-based practice platforms to ensure your preparation matches the real exam environment. "
            ]}
          />
        </div>

        <SkillAreas
          skillAreaTitle={skillAreaTitle}
          lifestyleCards={lifestyleCards}
          btnText={"Register For A Free Demo Class"}
          img={"/images/web-new-images/new-dark-arrow.svg"}
          skillSubtitle={"Experience our teaching style through structured tutorial sessions designed to simplify complex question types and improve scoring techniques."}
          noTilt
          padding={"p-80"}
        />
        <SkillAreas
          className={"skill-section"}
          background={"white"}
          color={"black"}
          skillAreaTitle={skillAreaTitle2}
          lifestyleCards={styleCards}
          leftSection={false}
          center={"d-flex justify-content-center text-center"}
          noTilt
          btnText2={"Enroll in Our PTE Online Caching VIC Program"}
        />
        <SkillAreas
          className={"skill-section"}
          background={"white"}
          color={"black"}
          skillAreaTitle={skillAreaTitle3}
          lifestyleCards={styleCards2}
          noTilt
          skillCardClass={
            styleCards2.length <= 4
              ? `col-md-6 col-lg-${12 / styleCards2.length} d-flex`
              : "col-md-6 col-lg-3 d-flex"
          }
          skillSubtitle={"Our PTE Preparation Online in Victoria programs are divided into structured modules for steady progress. "}
        padding="pb-0"
        />

        <div className="custom-container py-5">
         <div className="d-flex justify-content-center text-center mb-5">
           {skillAreaTitle4()}
         </div>
         <div className="course-card-data"
          >
         {tableData.map((card, index) => (
         <CourseCard key={card.id} card={card} index={index} />
         ))}
         </div>
          <div className="d-flex justify-content-center mt-5">
            <ButtonComp link={"/auth/register"} btnText={"Enroll Now and Secure Your Seat"} className={"mt-4"} />
          </div>
        </div>

        <div className="mt-4">
          <TestimonialSection
            extraClass={"flex-column flex-lg-row text-start"}
            extraWidth={"700px"}
            title={`<span class="hero-title FS40FW600 mb-0">Success Stories from <br/><span class="green-text">Victoria Students</span></span>`}
            subtitle={"<span style={{maxWidth: '700px'}}>Students from Melbourne, Geelong, and regional VIC have achieved outstanding results through structured online preparation. </span>"}
            showBtn={true}
            sliderList={sliderList}
            btnText={"Join Our Success Community Today"}
            titleClass={"text-start"}
          />
        </div>

        <TestSection
          data={testData}
          bgColor="#080F1E" 
          extraClass={"custom-list-spacing"}
          />
          <div style={{ padding: "40px 0 30px 0" }}>
          <CtaBanner
            title="Ready To Test Your"
            highlight="Level?"
            buttonText="Book Free Consultation"
            onClick={openPopup}
            rightImage="/images/web-new-images/HomePageImage/CTA-Image.webp"
            btnText="Take Free Mock Test"
            subTitle={"Take a free mock test and understand your current standing before enrolling."}
          />
        </div>

        <FaqSection questions={faqQuestions} />
        <CTAContactSection
          heading={
            <>
              Get Your{" "}
              <span className="text-success FS40FW600">
                Customized PTE Online Course
              </span>{" "}
              Quote Today
            </>
          }
          subHeading="Every student has different goals. We design your preparation plan based on your target score and timeline."
          topRowCards={[
            {
              title: "Phone / WhatsApp",
              icon: IconCall,
              content: <p style={{ fontSize: "15px", fontWeight: 700, color: "#fff", margin: 0 }}>+61 426 230 061</p>,
            },
            {
              title: "Email",
              icon: IconEmail,
              content: <p style={{ fontSize: "15px", fontWeight: 700, color: "#fff", margin: 0 }}>info@languageacademy.com.au</p>,
            },
            {
              title: "WhatsApp",
              icon: IconChats,
              content: <p style={{ fontSize: "15px", fontWeight: 700, color: "#fff", margin: 0 }}>Quick consultation available</p>,
            },
            {
              title: "Walk-in",
              icon: IconLocation,
              content: <p style={{ fontSize: "15px", fontWeight: 700, color: "#fff", margin: 0 }}>Visit any of our <a href="/branches" target="_blank" rel="noopener noreferrer" style={{ color: "#fff", textDecoration: "underline" }}>centres</a></p>,
            },
          ]}
          bottomRowCards={[
            {
              title: "Consultation Hours",
              icon: IconClock,
              content: (
                <ul style={{ margin: 0, padding: "0 0 0 18px", display: "flex", flexDirection: "column", gap: "6px" }}>
                  <li className="list-disc" style={{ fontSize: "14px", fontWeight: 600, color: "#fff", lineHeight: 1.5 }}>
                    Monday–Thursday: 9:00 AM – 5:00 PM
                  </li>
                  <li className="list-disc" style={{ fontSize: "14px", fontWeight: 600, color: "#fff", lineHeight: 1.5 }}>
                    Saturday: 9:00 AM – 5:00 PM
                  </li>
                </ul>
              ),
            },
            {
              title: "Phone / WhatsApp",
              icon: IconInfo,
              content: (
                <ul style={{ margin: 0, padding: "0 0 0 18px", display: "flex", flexDirection: "column", gap: "6px" }}>
                  <li className="list-disc" style={{ fontSize: "14px", fontWeight: 600, color: "#fff", lineHeight: 1.5 }}>
                    Call <a href="tel:+61426230061" style={{ color: "#fff", textDecoration: "underline" }}>+61 426 230 061</a> for immediate assistance
                  </li>
                  <li className="list-disc" style={{ fontSize: "14px", fontWeight: 600, color: "#fff", lineHeight: 1.5 }}>
                    WhatsApp <a href="https://wa.me/61426230061" target="_blank" rel="noopener noreferrer" style={{ color: "#fff", textDecoration: "underline" }}>+61 426 230 061</a> for quick queries
                  </li>
                  <li className="list-disc" style={{ fontSize: "14px", fontWeight: 600, color: "#fff", lineHeight: 1.5 }}>
                    Email <a href="mailto:info@languageacademy.com.au" style={{ color: "#fff", textDecoration: "underline" }}>info@languageacademy.com.au</a> for detailed inquiries
                  </li>
                </ul>
              ),
            },
          ]}
          cta={{
            label: "Schedule Your Free PTE Consultation Now",
            onClick: openPopup,
          }}
        />

        <Footer />
      </div>
    </React.Fragment>
  );
};

export default Victoria;

